import {
  ExecutedAutomation,
  mockEntityDisplayQueryOperationQuery,
  mockEntityExecutedAutomationsQueryOperationQuery,
  mockInsightDisplayQueryOperationQuery,
  mockInsightExecutedAutomationQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockEntityExecutedAutomations: ExecutedAutomation[] = [
  {
    __typename: 'ExecutedAutomation',
    executionId: '3',
    cseResourceType: 'ENTITY',
    cseResourceId: 'entity-1',
    playbookId: '1',
    playbookName: 'Playbook 1',
    playbookDescription:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eum eos enim mollitia iste exercitationem autem fugiat. Temporibus, in tempore iste sequi quo fugiat fugit labore sit ea pariatur itaque corporis.',
    startDate: '2023-01-19T20:30:56',
    status: 'Not Executed',
    statusCode: 0,
  },
  {
    __typename: 'ExecutedAutomation',
    executionId: '4',
    cseResourceType: 'ENTITY',
    cseResourceId: 'entity-1',
    playbookId: '1',
    playbookName: 'Playbook 1',
    playbookDescription:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eum eos enim mollitia iste exercitationem autem fugiat. Temporibus, in tempore iste sequi quo fugiat fugit labore sit ea pariatur itaque corporis.',
    startDate: '2023-01-18T20:30:56',
    status: 'Completed',
    statusCode: 1,
  },
];

export const mockInsightExecutedAutomations: ExecutedAutomation[] = [
  {
    __typename: 'ExecutedAutomation',
    executionId: '1',
    cseResourceType: 'INSIGHT',
    cseResourceId: 'insight-1',
    playbookId: '1',
    playbookName: 'Playbook 1',
    playbookDescription:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eum eos enim mollitia iste exercitationem autem fugiat. Temporibus, in tempore iste sequi quo fugiat fugit labore sit ea pariatur itaque corporis.',
    startDate: '2023-01-19T20:30:56',
    status: 'Running',
    statusCode: 2,
  },
  {
    __typename: 'ExecutedAutomation',
    executionId: '2',
    cseResourceType: 'INSIGHT',
    cseResourceId: 'insight-1',
    playbookId: '1',
    playbookName: 'Playbook 1',
    playbookDescription:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eum eos enim mollitia iste exercitationem autem fugiat. Temporibus, in tempore iste sequi quo fugiat fugit labore sit ea pariatur itaque corporis.',
    startDate: '2023-01-18T20:30:56',
    status: 'Running',
    statusCode: 2,
  },
];

export const mockExecutedAutomations: ExecutedAutomation[] = [
  ...mockEntityExecutedAutomations,
  ...mockInsightExecutedAutomations,
];

export const handlers = [
  // READ INSIGHT'S EXECUTED AUTOMATIONS
  mockInsightExecutedAutomationQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insight: {
            __typename: 'Insight',
            id: 'insight-1',
            executedAutomations: mockExecutedAutomations,
          },
        },
      });
    }
  ),

  // READ ENTITY'S EXECUTED AUTOMATIONS
  mockEntityExecutedAutomationsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entity: {
            __typename: 'EntityInterface',
            id: 'entity-1',
            executedAutomations: mockExecutedAutomations,
          },
        },
      });
    }
  ),

  // READ INSIGHT DISPLAY
  mockInsightDisplayQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(250);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insight: {
            __typename: 'Insight',
            id: 'insight-1',
            readableId: 'INSIGHT-17074',
            name: 'Persistence with Execution',
          },
        },
      });
    }
  ),

  // READ ENTITY DISPLAY
  mockEntityDisplayQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(250);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entity: {
            __typename: 'EntityInterface',
            id: 'entity-1',
            entityTypeName: 'IP Address',
            value: '94.180.253.213',
          },
        },
      });
    }
  ),
];

export {
  mockEntityDisplayQueryOperationQuery,
  mockEntityExecutedAutomationsQueryOperationQuery,
  mockInsightDisplayQueryOperationQuery,
  mockInsightExecutedAutomationQueryOperationQuery,
};
